export default (state = [], action) => {
  let { type, payload } = action
  switch (type) {
    case 'ROUTES_SET':
      return payload
    case 'ROUTE_CREATE':
      return [payload, ...state.filter(item => item.id != payload.id)]
    case 'ROUTE_UPDATE':
      return state.map(item => (item.id == payload.id ? payload : item))
    case 'ROUTE_DELETE':
      return state.filter(item => item.id != payload)
    case 'LOGOUT':
      return []
    default:
      return state
  }
}
